import { Loader2 } from "lucide-react";

export default function Loading({ text = "Carregando...", ...props }) {
  return (
    <div className="loading" {...props}>
      <Loader2 size={16} className="animate-spin inline" /> {text}
    </div>
  );
}
